import type { ReactNode } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkCheckbox from '@skyscanner/backpack-web/bpk-component-checkbox';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { FilterOption } from '@shared/types/frontend/ubff/hotel-detail-price';
import type { FilterExtendedButton } from '@shared/ui/types';

import STYLES from './MobilePartnersFilter.module.scss';

import { buildOfferFiltersMBDAttributes } from '@hotels-hotel-detail/utils/meaningful-behaviour-data/offer-filters';
import SemiModal from '@shared/ui/common/SemiModal';

const cls = cssModules(STYLES);

type Props = {
  isOpen: boolean;
  onClose: (event?: PopStateEvent) => void;
  title: string;
  partnerChips: FilterOption[];
  footer: ReactNode;
  handleCheckboxChange: (displayName: string) => void;
  clearAllButton: FilterExtendedButton;
};

const MobilePartnersFilter = ({
  clearAllButton,
  footer,
  handleCheckboxChange,
  isOpen,
  onClose,
  partnerChips,
  title,
}: Props) => {
  const clearBtn = (
    <BpkButtonV2
      onClick={clearAllButton.onClick}
      disabled={clearAllButton.disabled}
      type={BUTTON_TYPES.link}
      aria-label={`${clearAllButton.label} ${title}`}
    >
      <BpkText textStyle={TEXT_STYLES.label2}>{clearAllButton.label}</BpkText>
    </BpkButtonV2>
  );
  return (
    <SemiModal
      id="partners-filter-modal"
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      clearBtn={clearBtn}
      divideFooter
      enableScrollDivider
    >
      <div>
        {partnerChips.map(({ displayName, option, selected }) => (
          <div
            key={`partners-filter-modal-${option}`}
            className={cls('MobilePartnersFilter__labelContainer')}
          >
            <BpkCheckbox
              name={displayName}
              label={displayName}
              checked={selected}
              aria-label={displayName}
              className={cls('MobilePartnersFilter__checkbox')}
              onChange={() => {
                handleCheckboxChange(displayName);
              }}
              {...buildOfferFiltersMBDAttributes(displayName)}
            />
          </div>
        ))}
      </div>
    </SemiModal>
  );
};

export default MobilePartnersFilter;
